import styled from 'styled-components'

const Subhed = styled.h2`
  font-size: 14px;
  line-height: 22px;
  text-transform: uppercase;
`

export default Subhed
